import React, { useState, useEffect } from "react";

import HeaderGo from "../../components/headergo";

import Footer from "../../components/footergo";
import FloatingButtons from "../../components/floatinggo";

import "./travelhome.css";
import banner2 from "./homebanner1.png";
import banner1 from "./homebanner2.png";
import banner3 from "./homebanner3.png";

import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";

export default function TravelHomePage() {
    
    const bannerImages = [banner1, banner2, banner3];

    const [pickup, setPickup] = useState("");
    const [destination, setDestination] = useState("");

    const [tripType, setTripType] = useState("oneway");
    const [pickupDate, setPickupDate] = useState("");
    const [pickupTime, setPickupTime] = useState("");
    const [returnDate, setReturnDate] = useState("");

    const [distance, setDistance] = useState(null);
    const [price, setPrice] = useState(null);
    const [showResult, setShowResult] = useState(false);

    const swapLocations = () => {
        setPickup(destination);
        setDestination(pickup);
    };

    // 🔥 AUTO SCROLL BANNER
    useEffect(() => {
        const container = document.getElementById("promo-carousel");

        const autoScroll = () => {
            if (!container) return;

            if (
                container.scrollLeft + container.clientWidth >=
                container.scrollWidth - 10
            ) {
                container.scrollTo({ left: 0, behavior: "smooth" });
            } else {
                container.scrollBy({
                    left: container.offsetWidth * 0.8,
                    behavior: "smooth",
                });
            }
        };

        const interval = setInterval(autoScroll, 3500);
        return () => clearInterval(interval);
    }, []);

    // 🔥 BUTTON SCROLL
    function scrollPromo(direction) {
        const container = document.getElementById("promo-carousel");
        if (!container) return;

        const scrollAmount = container.offsetWidth * 0.8;

        if (direction === "left") {
            container.scrollLeft -= scrollAmount;
        } else {
            container.scrollLeft += scrollAmount;
        }
    }

    // 🔥 Dummy price calculation
    const calculatePrice = () => {
        if (!pickup || !destination || !pickupDate || !pickupTime) {
            alert("Please fill all required fields");
            return;
        }

        // 🔥 TEMP DUMMY (replace with Google API later)
        const pickupToDrop = Math.floor(Math.random() * 30) + 10; // 10–40 km
        const garageToPickup = Math.floor(Math.random() * 10) + 2; // 2–12 km

        const ratePerKm = 20;
        const baseFare = 50;

        let totalDistance = pickupToDrop + garageToPickup;

        // 🔥 round trip logic
        if (tripType === "round") {
            totalDistance = totalDistance * 2;
        }

        // 🔥 MINIMUM DISTANCE LOGIC
        const minDistance = tripType === "round" ? 150 : 75;

        if (totalDistance < minDistance) {
            totalDistance = minDistance;
        }

        const totalFare = baseFare + (totalDistance * ratePerKm);

        // ✅ show only user journey distance
        setDistance(pickupToDrop);
        setPrice(totalFare);
        setShowResult(true);

        window.scrollTo({ top: 650, behavior: "smooth" });
    };

    return (
        <div style={{ backgroundColor: "#f7ead7", paddingBottom: "100px" }}>

            <HeaderGo />
            {/* <Navbargo /> */}

            {/* ================= PROMO BANNER ================= */}
            <section className="container promo-carousel-container">

                <button className="promo-btn left" onClick={() => scrollPromo("left")}>
                    <i className="bi bi-chevron-left"></i>
                </button>

                <div id="promo-carousel" className="promo-carousel-wrapper">
                    {bannerImages.map((img, index) => (
                        <div
                            key={index}
                            className="promo-banner"
                            style={{
                                backgroundImage: `url(${img})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center"
                            }}
                        >
                            <div className="promo-content text-white">
                                {/* Optional Text */}
                            </div>
                        </div>
                    ))}
                </div>

                <button className="promo-btn right" onClick={() => scrollPromo("right")}>
                    <i className="bi bi-chevron-right"></i>
                </button>

            </section>

            {/* ================= BOOKING CARD ================= */}
            <div className="container booking-wrapper">
                <div className="mx-auto booking-card">

                    <h3 className="fw-bold mb-4 text-center">Book Your Ride</h3>

                    <input
                        type="text"
                        className="form-control rounded-pill mb-2"
                        placeholder="Pickup location"
                        value={pickup}
                        onChange={(e) => setPickup(e.target.value)}
                    />

                    <input
                        type="text"
                        className="form-control rounded-pill mb-3"
                        placeholder="Drop location"
                        value={destination}
                        onChange={(e) => setDestination(e.target.value)}
                    />

                    <div className="text-center mb-3">
                        <button className="btn btn-sm btn-outline-dark" onClick={swapLocations}>
                            Swap Locations
                        </button>
                    </div>

                    <div className="d-flex gap-2 mb-3">
                        <button
                            className={`btn w-50 ${tripType === "oneway" ? "btn-dark" : "btn-outline-dark"}`}
                            onClick={() => setTripType("oneway")}
                        >
                            One Way
                        </button>
                        <button
                            className={`btn w-50 ${tripType === "round" ? "btn-dark" : "btn-outline-dark"}`}
                            onClick={() => setTripType("round")}
                        >
                            Round Trip
                        </button>
                    </div>

                    <div className="d-flex gap-2 mb-3">
                        <input
                            type="date"
                            className="form-control rounded-pill"
                            value={pickupDate}
                            onChange={(e) => setPickupDate(e.target.value)}
                        />
                        <input
                            type="time"
                            className="form-control rounded-pill"
                            value={pickupTime}
                            onChange={(e) => setPickupTime(e.target.value)}
                        />
                    </div>

                    {tripType === "round" && (
                        <input
                            type="date"
                            className="form-control rounded-pill mb-3"
                            value={returnDate}
                            onChange={(e) => setReturnDate(e.target.value)}
                        />
                    )}

                    <button className="btn custom-btn w-100 rounded-pill" onClick={calculatePrice}>
                        See Price
                    </button>

                </div>
            </div>

            {/* ================= RESULT ================= */}
            {showResult && (
                <div className="container mt-4 mb-5">
                    <div className="result-card">

                        <h5 className="fw-bold mb-3">Trip Summary</h5>

                        <p><strong>Distance:</strong> {distance} km</p>
                        <p><strong>Estimated Fare:</strong> ₹{price}</p>

                        <hr />

                        <h6 className="fw-bold">Inclusions</h6>
                        <ul>
                            <li>Driver charges</li>
                            <li>Fuel included</li>
                            <li>Basic toll</li>
                        </ul>

                        <h6 className="fw-bold">Exclusions</h6>
                        <ul>
                            <li>Parking charges</li>
                            <li>State tax</li>
                        </ul>

                        <button className="btn btn-dark w-100 mt-3">
                            Book Now
                        </button>

                    </div>
                </div>
            )}

            <Footer />
            <FloatingButtons />
        </div>
    );
}